import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }
  public isLoading = new BehaviorSubject<boolean>(false);

  show() {
    this.isLoading.next(true);
  }

  hide() {
    this.isLoading.next(false);
  }

  
  private updateTItle = new Subject<any>();

  updateVideo$ = this.updateTItle.asObservable();

  updateVideoStatus(status:boolean) {
    console.log('trigger')
    this.updateTItle.next(status);
  }




}
